import { FaBrain } from "react-icons/fa";

const OnboardingIntroduction = (props: { onNext: any }) => {
    const { onNext } = props;
    return (
        <div className="flex flex-col items-center justify-between min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 text-center px-6 py-12">
            <div></div>
            <div className="flex flex-col items-center">
                <div className="bg-gradient-to-br from-orange-400 to-orange-500 rounded-full p-6 mb-8 relative shadow-lg">
                    <div className="w-20 h-20 flex items-center justify-center">
                        <FaBrain className="text-white" size={50} />
                    </div>
                </div>
                <h1 className="text-4xl font-bold text-gray-900 mb-4">
                    Bienvenue sur DuckFlow 👋
                </h1>
                <p className="mt-2 text-gray-600 max-w-xl text-lg leading-relaxed">
                    Votre copilote intelligent pour la prospection dans le secteur{" "}
                    <span className="font-semibold text-orange-600">CHR</span>
                    <br /> <br />
                    Nous allons personnaliser votre expérience en quelques questions.
                    <br />
                    Cela ne prendra que 2 minutes.
                </p>
            </div>
            <div className="w-full max-w-2xl">
                <button
                    className="w-full px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl hover:from-orange-600 hover:to-orange-700 transition-all text-lg"
                    onClick={onNext}
                >
                    Continuer
                </button>
                <p className="mt-6 text-gray-400 text-sm">
                    Cafés • Hôtels • Restaurants
                </p>
            </div>
        </div>
    );
};
export default OnboardingIntroduction;
